// import "./assets/css/bootstrap.css";
import "./assets/css/tema-sae.css";
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import router from "./router";
import * as VueGoogleMaps from "vue2-google-maps";

import AxiosPlugin from 'vue-axios-cors';
Vue.use(AxiosPlugin)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB5XH18yZY2urY6TDDZ1CHpICaoRAS5Hm0"
  }
});
Vue.config.productionTip = false;
Vue.use(VueRouter);

new Vue({
  router,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
